@if (appState.loading) {
    <arc-loading [muestraLoading]="true" mensaje="Cargando..."></arc-loading>
}
<router-outlet></router-outlet>